// Static content for Hemlock Labs — a private holding company (family-office style)

export const HERO = {
  eyebrow: "Private Holding Company · Est. MMXIV",
  lines: ["A private", "holding company", "built to endure."],
  sub: "Hemlock Labs acquires, builds and holds companies for the long term — with deep, active involvement in healthcare and health technology.",
  bg: "https://images.unsplash.com/photo-1702474447694-e8c8dc2508e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbWlzdHklMjBldmVyZ3JlZW4lMjBwaW5lJTIwZm9yZXN0JTIwZm9nfGVufDB8fHx8MTc4NjQwNzY5Mnww&ixlib=rb-4.1.0&q=85",
};

export const ETHOS = {
  image:
    "https://images.unsplash.com/photo-1762270831784-deadac13950a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxjb25pZmVyJTIwbmVlZGxlcyUyMGJyYW5jaCUyMG1hY3JvJTIwZGFya3xlbnwwfHx8fDE3ODY0MDc2OTJ8MA&ixlib=rb-4.1.0&q=85",
  lines: [
    "We hold for the long term — no fund cycle, no clock.",
    "We concentrate where we have conviction, led by healthcare & health technology.",
    "We stay privately held, and deliberately low-profile.",
  ],
};

export const CONTACT = {
  address: "New York City",
  note: "Enquiries welcome.",
};
